import React, { useRef } from 'react';
import Calendar, { CalendarProps } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import * as S from './styles';
import { Value } from 'react-calendar/dist/esm/shared/types.js';
import { Modal, ModalTrigger } from '../Modal';
import { Button } from '../Button';
import { convertToDateInput } from '../../utils/stringUtil';


export interface TimePickerProps extends CalendarProps {
  name?: string
  form?: boolean
  children?: React.ReactNode
  // eslint-disable-next-line no-unused-vars
  onChangeData?: (data : Date)=>void
}

export function TimePicker (props: TimePickerProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  function convertToDate (value: Value): Date | null  {
    if (!value) return null;
    if (Array.isArray(value)) return value[0]; 
    return value;
  }

  function onChange (value: Value, event: React.MouseEvent<HTMLButtonElement>) {
    const currentDate = convertToDate(value);
    if (props.form && fileInputRef.current) {
    if (fileInputRef.current) {

      
      if (currentDate) {
          const formattedDate = convertToDateInput(currentDate);
          fileInputRef.current.value = formattedDate;
          fileInputRef.current.defaultValue = formattedDate;
      }
  }


    }
    currentDate && props.onChangeData && props.onChangeData(currentDate)
    props.onChange && props.onChange(value, event)
  }

  const propsOverride = {
    ...props,
    onChange: onChange
  };

  function componentCalendar() {
    return <Calendar {...propsOverride} />
  }
  
  return (
    <S.CalendarWrapper>
      {props.children ?
        <Modal>
          <ModalTrigger asChild>
            {props.children}
          </ModalTrigger>
          <S.CalendarModalContent>
            {componentCalendar()}
            <ModalTrigger asChild>
              <Button style={{ marginTop: 10 }} size='lg'>Ok!</Button>
            </ModalTrigger>
          </S.CalendarModalContent>
        </Modal>
        :
        componentCalendar()
      }
       {props.form == true &&
        <input type="date" name={props.name} ref={fileInputRef} style={{display:"none"}} />
      }
    </S.CalendarWrapper>
  )
}

export default TimePicker;